import React from 'react'
import ReactDOM from 'react-dom'

export default class Item extends React.Component {

  render() {
    if (this.props.item.returned) {
      return (
        <p>
          <img src={this.props.item.product.picture_url} className="img-fluid" alt="item picture" />
          <span className="value">
            {this.props.item.label}
          </span>
        </p>
      )
    } else {
      return (<div></div>)
    }
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/components/Item.jsx